import { bootstrapApplication } from '@angular/platform-browser';
import { resolveApiUrl } from '@catch/libs';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

const initializeApp = async () => {
  environment.apiUrl = await resolveApiUrl(
    environment.apiUrl,
    environment.apiUrlFallback,
    { enabled: !environment.production }
  );

  bootstrapApplication(AppComponent, appConfig)
    .then(() => console.log('Bootstrap success'))
    .catch((err) => console.error(err));
};

initializeApp();
